import { SeoReplaceValues } from 'libs/shared-lib/interfaces';
import { ServicesSeoConfig } from 'libs/shared-lib/interfaces/seo/seo-partner-web';

export const SERVICE_SEO_DE: ServicesSeoConfig = {
    list: {
        title: `${SeoReplaceValues.DEALER_NAME}: Unsere Serviceleistungen`,
        description: '',
        image: '',
        twitter: {
            card: 'summary',
            title: `${SeoReplaceValues.DEALER_NAME}: Unsere Serviceleistungen`,
            description: '',
        },
        og: {
            title: `${SeoReplaceValues.DEALER_NAME}: Unsere Serviceleistungen`,
            description: '',
        },
        robots: {
            noIndex: false,
            noFollow: false,
        },
    },
    detail: {
        title: 'Service Detail',
        description: '',
        image: '',
        twitter: {
            card: 'summary',
            title: 'service-detail',
            description: '',
        },
        og: {
            title: 'Service Detail',
            description: '',
        },
        robots: {
            noIndex: false,
            noFollow: false,
        },
    },
};
